export default "__VITE_ASSET__C3AD6jyw__"